export default class MuseConfig {
  noteHeight = 22;
  noteWidth = 11;
  noteFontSize = 22;
  noteFontFamily = "serif";
  sigFontSize = 14;

  trackGap = 10;

  lineGap = 40;

  pointGap = 5;
  tailPointGap = 8;
  pointRound = 1.5;

  pageE = 1.414;
  pageWidth = 1000;
  pageMarginHorizontal = 100;
  pageMarginVertical = 110;

  infoTitleFontSize = 34;
  infoSubtitleFontSize = 22;
  infoGap = 7;
  infoFontSize = 20;

  pageIndexFontSize = 20;

  textFontFamily = "serif";

  showBorder = false;
}
